var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
        'callback': _vm.visibility_changed,
        'throttle': 50,
    }),expression:"{\n        'callback': visibility_changed,\n        'throttle': 50,\n    }"}]},[(!_vm.drawn)?_c('v-skeleton-loader',{style:({
                position: 'absolute',
                top: 0,
                left: 0,
            }),attrs:{"tile":"","width":_vm.width,"height":_vm.height,"type":"image, image"}}):_vm._e(),_c('canvas',{ref:"canvas",style:({
            width: _vm.width + 'px',
            height: _vm.height + 'px',
        }),attrs:{"width":_vm.width * _vm.dpr,"height":_vm.height * _vm.dpr}}),_c('svg',{ref:"svg",attrs:{"viewBox":("0 0 " + _vm.width + " " + _vm.height),"width":_vm.width,"height":_vm.height},on:{"mousemove":_vm.mousemove,"mouseleave":_vm.mouseleave}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }